import FocusTrap from './FocusTrap';

export default FocusTrap;